var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAddGuest = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.55 10.202a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6m4.5-3.3c0 1.575-.808 2.96-2.033 3.764.54.208 1.054.485 1.529.824.29.207.232.639-.068.83l-.112.074a.56.56 0 0 1-.626-.003 5.67 5.67 0 0 0-3.19-.985 5.7 5.7 0 0 0-4.031 1.682 5.87 5.87 0 0 0-1.702 4.084v2.119a.5.5 0 0 0 .5.5h6.189c.214 0 .402.136.482.335l.034.08c.15.358-.095.785-.483.785H3.737c-.297 0-.582-.12-.792-.332a1.14 1.14 0 0 1-.328-.802v-2.69A7.07 7.07 0 0 1 4.67 12.24a6.9 6.9 0 0 1 2.413-1.575 4.5 4.5 0 1 1 6.968-3.764m3.148 6.351a.6.6 0 0 1 .6.6v2.85h2.985a.6.6 0 1 1 0 1.2h-2.985v3.095a.6.6 0 0 1-1.2 0v-3.096h-2.96a.6.6 0 0 1 0-1.2h2.96v-2.849a.6.6 0 0 1 .6-.6",
  clipRule: "evenodd"
})));
export { SvgIconAddGuest as ReactComponent };